export default "__VITE_ASSET__7nBblxQ8__"